const ChartSubsection = ({gradeLevel}: any) => {

    return (
        <div>
            <div
                key={gradeLevel.level}
                className={`subsection ${gradeLevel.isMarked} ${gradeLevel.cssClass}`}
            >
                <div>
                    {Array.isArray(gradeLevel.description) ? (
                        <ul>
                            {gradeLevel.description.map((description: any, index: any) => (
                                <li key={index}>{description}</li>
                            ))}
                        </ul>
                    ) : (
                        <div dangerouslySetInnerHTML={{__html: gradeLevel.description}}/>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ChartSubsection;
